import React from "react";
import telecareLogo from "../assets/telecare-logo.svg";
import { HospitalLogo } from "./Shared/HospitalLogo";

const AppHeader = ({ signOut }) => {
  return (
    <nav className="navbar app-header mb-3" role="navigation" aria-label="main navigation">
      <div className="navbar-brand">
        <HospitalLogo klassName="logo-large" />
      </div>
      <div className="navbar-menu">
        <div className="navbar-end">
          <div className="navbar-item">
            <img src={telecareLogo} alt="Telecare Logo" className="telecare-logo-large" />
          </div>
          <div className="navbar-item">
            <button className="button is-primary is-small is-radiusless" onClick={signOut}>
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AppHeader;
